import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { ReferralStats } from '../../types/admin/AdminTypes';

interface ReferralStatsCardProps {
  stats: ReferralStats;
}

const ReferralStatsCard: React.FC<ReferralStatsCardProps> = ({ stats }) => {
  const totalRevenue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(stats.totalRevenue);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid #e0e0e0',
        height: '100%'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <ShareIcon sx={{ color: '#1976d2' }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Referral Stats
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-around', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography 
            variant="h4" 
            sx={{ fontWeight: 700, color: '#f44336' }}
          >
            {stats.totalReferrals}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Total Indicações
          </Typography>
        </Box>
        
        <Box sx={{ textAlign: 'center' }}>
          <Typography 
            variant="h4" 
            sx={{ fontWeight: 700, color: stats.conversionRate > 0 ? '#4caf50' : '#f44336' }}
          >
            {stats.conversionRate.toFixed(1)}%
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Taxa de Conversão
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: '#1976d2' }}
          >
            {totalRevenue}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Receita Estimada
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ReferralStatsCard;
